import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import { TableContainer, Tooltip } from '@material-ui/core';
export const StyledTableContainer = styled(TableContainer)``;
export const StyledCard = styled(Card)`
  && {
    width: auto;
    margin: 0px;
    box-shadow: none;
  }
`;
export const StyledTooltip = styled(Tooltip)`
  font-family: 'OpenSans-Regular' !important;
  display: block;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 22px !important;
  line-height: 1.5;
`;
export const StyledDiv = styled.div`
  display: block;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const StyledSpan = styled.span`
  text-align: center;
`;
export const StyledCustomCell = styled.div`
  padding: '6px 10px' !important;
  font-size: '13px' !important;
`;